import type Eshop from '@eshop/type/eshop'
import type Rental from '@eshop/type/rental'

import i18n from './i18n'
import css from './index.module.css'

import { Config } from '#/global/helper/Config'

interface Props {
    product: Eshop.Product<'detail'> | Rental.Product<'detail'>
}

export const ProductIcon = ({ product }: Props) => {
    const lang = Config.getLang()
    const t = i18n[lang]

    if (product.type === 'eshop') {
        return (
            <div className={`r-product-icon ${css.icons}`}>
                {product.detail.hasVariant && (
                    <img
                        title={t.hasVariants}
                        alt={t.hasVariants}
                        src="https://cdn1.idek.cz/img/a32ef0de7bf6d55e5b00748dfe951840_rw24.png"
                        width={24}
                        height={24}
                    />
                )}
                {product.detail.hasGift && (
                    <img
                        alt={t.hasGift}
                        title={t.hasGift}
                        src="https://cdn1.idek.cz/img/13ac7588db7f1b49cbce256f5abd255f_rw24.png"
                        width={24}
                        height={24}
                    />
                )}
                {product.detail.hasPpl && (
                    <img
                        title={t.hasPpl}
                        alt={t.hasPpl}
                        src="https://cdn1.idek.cz/img/8c6599f32f6f4d9cbc8d20951dba4952_rw24.jpg"
                        width={24}
                        height={24}
                    />
                )}
            </div>
        )
    }

    if (product.type === 'rental') {
        return (
            <div className={`r-product-icon ${css.icons}`}>
            </div>
        )
    }
}
